import { Box, Checkbox } from "@mui/material";
import DirectionsCarIcon from "@mui/icons-material/DirectionsCar";
import DirectionsBusIcon from "@mui/icons-material/DirectionsBus";
import FontDownloadOffIcon from "@mui/icons-material/FontDownloadOff";
import QuestionMarkIcon from "@mui/icons-material/QuestionMark";
import NotificationsActiveIcon from "@mui/icons-material/NotificationsActive";
import LocalPhoneIcon from "@mui/icons-material/LocalPhone";
import WorkIcon from "@mui/icons-material/Work";
import PhoneInTalkIcon from "@mui/icons-material/PhoneInTalk";
import React from "react";

const IconButtonGroup = ({
  wholeCar, setWholeCar,
  wholeBus, setWholeBus,
  isInactive, setIsInactive,
  hasQuestionmark, setHasQuestionmark,
  hasNotification, setHasNotification,
  sendPhoneNumber, setSendPhoneNumber,
  hasLuggage, setHasLuggage,
  greenPhone, setGreenPhone,
}) => {

  const buttons = [
    { state: wholeCar, setState: setWholeCar, icon: <DirectionsCarIcon /> },
    { state: wholeBus, setState: setWholeBus, icon: <DirectionsBusIcon /> },
    { state: isInactive, setState: setIsInactive, icon: <FontDownloadOffIcon /> },
    { state: hasQuestionmark, setState: setHasQuestionmark, icon: <QuestionMarkIcon /> },
    { state: hasNotification, setState: setHasNotification, icon: <NotificationsActiveIcon /> },
    { state: sendPhoneNumber, setState: setSendPhoneNumber, icon: <LocalPhoneIcon /> },
    { state: hasLuggage, setState: setHasLuggage, icon: <WorkIcon /> },
    { state: greenPhone, setState: setGreenPhone, icon: <PhoneInTalkIcon sx={{ color: "#1ca25bff" }} /> },
  ];

  return (
    <Box
      sx={{
        display: "flex",
        gap: "8px",
        flexWrap: "wrap",
        justifyContent: "center", // centriranje kartica u grupi
        padding: "16px",
        backgroundColor: "#f9fafb",
        borderRadius: "16px",
        margin: "16px 0",
      }}
    >
     {buttons.map((btn, idx) => {
  const isGreenPhone = btn.icon.type === PhoneInTalkIcon;

  return (
    <Box
      key={idx}
      onClick={() => btn.setState(!btn.state)}
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        gap: "4px",
        padding: "8px 12px",
        backgroundColor: btn.state ? "#6366f1" : "#fff",
        border: "2px solid",
        borderColor: btn.state ? "#6366f1" : "#e5e7eb",
        borderRadius: "10px",
        cursor: "pointer",
        transition: "all 0.2s ease",
        color: btn.state ? "#fff" : "inherit",
        minWidth: "64px",
        height: "48px",
      }}
    >
      <Checkbox
        checked={btn.state}
        onChange={(e) => btn.setState(e.target.checked)}
        sx={{ padding: 0, margin: 0 }}
      />
      {React.cloneElement(btn.icon, {
        sx: {
          color: isGreenPhone ? "#1ca25b" : btn.state ? "#fff" : "inherit",
        },
      })}
    </Box>
  );
})}

    </Box>
  );
};

export default IconButtonGroup;
